import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-left-doodle.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';
export default {
  name: 'TrendNavigation',
  props: {
    color: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    previous: {
      type: Object,
      required: true
    },
    next: {
      type: Object,
      required: true
    }
  },
  methods: {
    trackNavigation: function trackNavigation(event, trackingData) {
      if (trackingData.data.event_category) {
        this.$root.$emit('generic-tracking', event, trackingData);
      }
    }
  }
};